import moment = require("moment-timezone");

export function getCurrentPerformanceLocalTime(performanceTimeZone: string) {
    let currentLocalTime = moment();
    if (performanceTimeZone.length > 0) {
        currentLocalTime = moment().tz(performanceTimeZone);
    }
    return currentLocalTime;
}